module.exports = __webpack_public_path__ + "img/csv.118b6cbb.png";